import { TagValueForm } from "./TagValueForm";

export const TagValueEdit = () => {
    return <TagValueForm />;
};
